// https://axios.nuxtjs.org/helpers
import { Plugin } from '@nuxt/types'
import { AxiosError } from 'axios'

const axiosPlugin: Plugin = (ctx) => {
  const { $axios, store, redirect, $sentry } = ctx
  $axios.interceptors.response.use(null, (error: AxiosError) => {
    $sentry.captureException(error)
    // Preserve the original runtime: `error.response.status` is a number that is
    // handed to parseInt as-is (parseInt coerces it to a string at runtime).
    const code = parseInt((error.response && error.response.status) as unknown as string)
    if (code === 401) {
      store.commit('auth/SET_USER', {})
      redirect('/mijnexamenbundel/login')
    }
    return Promise.reject(error)
  })
}

export default axiosPlugin
